module.exports = __webpack_public_path__ + "img/c03_buildingtechtraderoutes_Normal_ua.2460f41f.webp";